/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `R20B_STAVOVA` - R20b neverejna stavova
 *   * `R20B_ZMENOVA` - R20b neverejna zmenova
 *   * `R21B_STAVOVA` - r21b verejna stavova
 *   * `R21B_ZMENOVA` - r21b verejna zmenova
 *   * `R22B_VSP` - r22b vsp
 *   * `R27A_VEREJNA` - r27a verejna
 *   * `R27A_NEVEREJNA` - r27a neverejna
 *   * `R30B_SYNCHRONIZACNI` - r30b synchronizacni
 * ```
 */
export const VydejDmvsSourceEnum = {
  R20B_STAVOVA: 'R20B_STAVOVA',
  R20B_ZMENOVA: 'R20B_ZMENOVA',
  R21B_STAVOVA: 'R21B_STAVOVA',
  R21B_ZMENOVA: 'R21B_ZMENOVA',
  R22B_VSP: 'R22B_VSP',
  R27A_VEREJNA: 'R27A_VEREJNA',
  R27A_NEVEREJNA: 'R27A_NEVEREJNA',
  R30B_SYNCHRONIZACNI: 'R30B_SYNCHRONIZACNI',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type VydejDmvsSourceEnum = ValuesOf<typeof VydejDmvsSourceEnum>;

export type VydejDmvsSourceEnumRequest = VydejDmvsSourceEnum;
export type VydejDmvsSourceEnumResponse = VydejDmvsSourceEnum;
